import { BUDGET_GAME_STATES } from "./constants";

export const EFFECT_ACTIONS = {
  SELECT_OPTION: "SELECT_OPTION",
  CREATE_BUDGET_PLAN: "CREATE_BUDGET_PLAN",
  UPDATE_BUDGET_CATEGORY: "UPDATE_BUDGET_CATEGORY",
};

/**
 * Effect definitions for state machine transitions.
 * Each state can define:
 * - onEnter: function called when entering the state
 * - onExit: function called when exiting the state
 *
 * Effects receive a context object with:
 * - dispatch: Function to dispatch actions through the controller
 * - Data needed for the effect (transfrId, currentBudgetCategoryCode, etc.)
 *
 * Effects dispatch actions rather than calling mutations directly,
 * ensuring all state changes flow through a single pipeline.
 */
export const effects = {
  [BUDGET_GAME_STATES.creatingPlan]: {
    /**
     * Dispatch action to create a new budget plan
     */
    onEnter: ({ dispatch, transfrId }) => {
      if (!transfrId) {
        console.warn("Cannot create budget plan without transfrId");
        return;
      }
      dispatch({
        type: EFFECT_ACTIONS.CREATE_BUDGET_PLAN,
        payload: { transfrId },
      });
    },
  },

  [BUDGET_GAME_STATES.budgeting]: {
    /**
     * Dispatch action to update current budget category in API
     */
    onEnter: ({ dispatch, budgetPlanId, currentBudgetCategoryCode }) => {
      if (!budgetPlanId || !currentBudgetCategoryCode) {
        return;
      }
      dispatch({
        type: EFFECT_ACTIONS.UPDATE_BUDGET_CATEGORY,
        payload: { categoryCode: currentBudgetCategoryCode },
      });
    },
  },
};

/**
 * Get the effect handler for a given state
 */
export const getStateEffect = (stateName, effectType = "onEnter") => {
  return effects[stateName]?.[effectType];
};
